import { render, staticRenderFns } from "./authorized_access_no_code.vue?vue&type=template&id=0c7ba57f&scoped=true"
import script from "./authorized_access_no_code.vue?vue&type=script&lang=js"
export * from "./authorized_access_no_code.vue?vue&type=script&lang=js"
import style0 from "./authorized_access_no_code.vue?vue&type=style&index=0&id=0c7ba57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ba57f",
  null
  
)

export default component.exports